// Script pour pré-remplir le formulaire de contact depuis l'URL
// et gérer l'abonnement Brevo après soumission réussie

(function() {
  'use strict';

  // Attacher le listener newsletter à tous les formulaires de contact
  function attachNewsletterListener() {
    console.log('Attempting to attach newsletter listener...');
    
    // Chercher le formulaire de contact par sa classe ou qui contient /contact dans l'action
    const form = document.querySelector('form.contact-form__form') ||
                 document.querySelector('form[action*="/contact"]') ||
                 document.querySelector('form[id*="ContactForm"]');
    console.log('Form found:', form);
    
    if (!form) {
      console.log('Contact form not found');
      return;
    }

    console.log('Attaching submit listener to form');
    
    form.addEventListener('submit', (e) => {
      console.log('Form submitted!');
      const newsletterCheckbox = form.querySelector('input[name="newsletter_optin"]');
      console.log('Newsletter checkbox:', newsletterCheckbox, 'Checked:', newsletterCheckbox?.checked);
      
      if (newsletterCheckbox && newsletterCheckbox.checked) {
        const emailField = form.querySelector('input[name="contact[email]"]');
        const firstNameField = form.querySelector('input[name="contact[first_name]"]');
        const lastNameField = form.querySelector('input[name="contact[last_name]"]');
        
        if (emailField && emailField.value) {
          // Envoyer immédiatement à Brevo AVANT le rechargement
          const email = emailField.value;
          const firstName = firstNameField ? firstNameField.value : '';
          const lastName = lastNameField ? lastNameField.value : '';
          
          console.log('Sending newsletter subscription to Brevo immediately:', { email, firstName, lastName });
          
          // Vérifier que la clé API existe
          if (window.brevoApiKey) {
            const brevoPayload = {
              email: email,
              attributes: {
                FIRSTNAME: firstName,
                LASTNAME: lastName
              },
              updateEnabled: true
            };

            // Envoi immédiat (fire and forget)
            fetch('https://api.brevo.com/v3/contacts', {
              method: 'POST',
              headers: {
                'api-key': window.brevoApiKey,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(brevoPayload)
            })
            .then(response => {
              if (response.ok) {
                console.log('Successfully subscribed to Brevo newsletter:', email);
              } else {
                console.warn('Brevo subscription failed with status:', response.status);
              }
            })
            .catch(error => {
              console.warn('Newsletter subscription error:', error);
            });
          } else {
            console.warn('Brevo API key not found');
          }
        }
      }
      // Le formulaire continue sa soumission normalement
    });
  }

  // Pré-remplir les champs depuis les paramètres URL
  function prefillFormFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type');
    
    // Ne pré-remplir que si c'est une demande professionnelle
    if (type !== 'professional') return;

    const form = document.querySelector('form[action="/contact"]');
    if (!form) return;

    // Mapper les paramètres URL aux champs du formulaire
    const fieldMapping = {
      'first_name': 'contact[first_name]',
      'last_name': 'contact[last_name]',
      'email': 'contact[email]',
      'phone': 'contact[phone]',
      'body': 'contact[body]'
    };

    // Pré-remplir les champs standards
    Object.keys(fieldMapping).forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        const fieldName = fieldMapping[param];
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (field) {
          field.value = decodeURIComponent(value);
        }
      }
    });

    // Pré-remplir le champ product_info s'il existe
    const productInfo = urlParams.get('product_info');
    if (productInfo) {
      let productInfoField = form.querySelector('[name="contact[product_info]"]');
      if (!productInfoField) {
        // Créer le champ s'il n'existe pas
        productInfoField = document.createElement('input');
        productInfoField.type = 'hidden';
        productInfoField.name = 'contact[product_info]';
        form.appendChild(productInfoField);
      }
      productInfoField.value = decodeURIComponent(productInfo);
    }

    // Pré-remplir les tags
    const tags = urlParams.get('tags');
    if (tags) {
      let tagsField = form.querySelector('[name="contact[tags]"]');
      if (!tagsField) {
        tagsField = document.createElement('input');
        tagsField.type = 'hidden';
        tagsField.name = 'contact[tags]';
        form.appendChild(tagsField);
      }
      tagsField.value = decodeURIComponent(tags);
    }

    // Construire le message avec les informations professionnelles
    const company = urlParams.get('company');
    const country = urlParams.get('country');
    const status = urlParams.get('status');
    const statusOther = urlParams.get('status_other');
    const body = urlParams.get('body');

    if (company || country || status || body) {
      let messageBody = '';
      
      if (productInfo) {
        messageBody += `Produit concerné: ${decodeURIComponent(productInfo)}\n\n`;
      }

      messageBody += 'Informations personnelles:\n';
      if (urlParams.get('first_name')) messageBody += `- Prénom: ${decodeURIComponent(urlParams.get('first_name'))}\n`;
      if (urlParams.get('last_name')) messageBody += `- Nom: ${decodeURIComponent(urlParams.get('last_name'))}\n`;
      if (urlParams.get('email')) messageBody += `- Email: ${decodeURIComponent(urlParams.get('email'))}\n`;
      if (urlParams.get('phone')) messageBody += `- Téléphone: ${decodeURIComponent(urlParams.get('phone'))}\n`;

      messageBody += '\nInformations professionnelles:\n';
      if (company) messageBody += `- Entreprise: ${decodeURIComponent(company)}\n`;
      if (country) messageBody += `- Pays: ${decodeURIComponent(country)}\n`;
      if (status) {
        let statusLabel = decodeURIComponent(status);
        if (status === 'gallery') statusLabel = 'Galerie';
        else if (status === 'architect') statusLabel = 'Architecte d\'intérieur';
        else if (status === 'other' && statusOther) statusLabel = `Autre: ${decodeURIComponent(statusOther)}`;
        messageBody += `- Statut: ${statusLabel}\n`;
      }

      if (body) {
        messageBody += `\nMessage:\n${decodeURIComponent(body)}`;
      }

      const bodyField = form.querySelector('[name="contact[body]"]');
      if (bodyField) {
        bodyField.value = messageBody;
      }
    }

    // Ajouter les données brevo dans un cookie si newsletter opt-in (depuis professional sidebar)
    const newsletterOptin = urlParams.get('newsletter_optin');
    if (newsletterOptin === '1' && form) {
      const data = {
        email: urlParams.get('email'),
        firstName: urlParams.get('first_name') || '',
        lastName: urlParams.get('last_name') || ''
      };
      if (data.email) {
        document.cookie = `brevo_subscribe=${encodeURIComponent(JSON.stringify(data))}; path=/; max-age=300; SameSite=Lax`;
        console.log('Newsletter subscription data stored in cookie from URL params');
      }
    }

    // Retourner le formulaire pour soumission automatique
    return form;
  }

  // Soumettre automatiquement le formulaire après pré-remplissage
  function autoSubmitForm(form) {
    if (!form) return;

    // Attendre un peu pour que Shopify génère le token CAPTCHA
    // et que tous les champs soient bien remplis
    setTimeout(() => {
      // Vérifier que tous les champs requis sont remplis
      const requiredFields = form.querySelectorAll('[required]');
      let allFilled = true;
      
      requiredFields.forEach(field => {
        if (!field.value || field.value.trim() === '') {
          allFilled = false;
        }
      });

      if (allFilled) {
        // Afficher un indicateur de chargement
        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitButton) {
          const originalText = submitButton.textContent || submitButton.value;
          submitButton.disabled = true;
          if (submitButton.textContent !== undefined) {
            submitButton.textContent = 'Envoi en cours...';
          } else {
            submitButton.value = 'Envoi en cours...';
          }
        }

        // Soumettre le formulaire
        form.submit();
      }
    }, 1000); // Attendre 1 seconde pour que le CAPTCHA soit prêt
  }

  // Gérer l'abonnement Brevo après soumission réussie
  function handleBrevoSubscription() {
    // Récupérer les données depuis le cookie
    const cookies = document.cookie.split(';');
    let brevoData = null;
    
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'brevo_subscribe') {
        try {
          brevoData = JSON.parse(decodeURIComponent(value));
          console.log('Found brevo subscription data in cookie:', brevoData);
        } catch (e) {
          console.warn('Failed to parse brevo cookie:', e);
        }
        break;
      }
    }
    
    if (!brevoData || !brevoData.email) {
      console.log('No brevo subscription data in cookie');
      return;
    }

    const email = brevoData.email;
    const firstName = brevoData.firstName || '';
    const lastName = brevoData.lastName || '';

    // Vérifier que la clé API est disponible
    if (!window.brevoApiKey) {
      console.warn('Brevo API key not found in window.brevoApiKey');
      return;
    }

    const brevoPayload = {
      email: email,
      attributes: {
        FIRSTNAME: firstName,
        LASTNAME: lastName
      },
      updateEnabled: true
    };

    console.log('Sending Brevo subscription request for:', email);

    fetch('https://api.brevo.com/v3/contacts', {
      method: 'POST',
      headers: {
        'api-key': window.brevoApiKey,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(brevoPayload)
    })
    .then(response => {
      if (response.ok) {
        console.log('Successfully subscribed to Brevo newsletter:', email);
        // Supprimer le cookie
        document.cookie = 'brevo_subscribe=; path=/; max-age=0';
      } else {
        console.warn('Brevo subscription failed with status:', response.status);
        return response.text().then(text => {
          console.warn('Brevo error response:', text);
          // Supprimer le cookie même en cas d'erreur
          document.cookie = 'brevo_subscribe=; path=/; max-age=0';
        });
      }
    })
    .catch(error => {
      console.warn('Newsletter subscription error:', error);
      // Supprimer le cookie même en cas d'erreur
      document.cookie = 'brevo_subscribe=; path=/; max-age=0';
    });
  }

  // Observer pour détecter l'apparition du message de succès
  function observeSuccessMessage() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const successMsg = node.classList?.contains('contact-form__success') 
              ? node 
              : node.querySelector?.('.contact-form__success');
            if (successMsg) {
              handleBrevoSubscription();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Vérifier si le formulaire vient d'être soumis avec succès
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('contact_posted') === 'true') {
        console.log('Contact form submitted successfully, checking for newsletter subscription');
        handleBrevoSubscription();
      } else {
        // Attacher le listener uniquement si on n'est pas sur la page de succès
        attachNewsletterListener();
        const form = prefillFormFromURL();
        
        // Si le formulaire a été pré-rempli (redirection depuis sidebar), le soumettre automatiquement
        if (form) {
          autoSubmitForm(form);
        }
      }
      
      // Observer pour détecter le succès si formulaire soumis sans rechargement
      observeSuccessMessage();
    });
  } else {
    // Vérifier si le formulaire vient d'être soumis avec succès
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_posted') === 'true') {
      console.log('Contact form submitted successfully, checking for newsletter subscription');
      handleBrevoSubscription();
    } else {
      // Attacher le listener uniquement si on n'est pas sur la page de succès
      attachNewsletterListener();
      const form = prefillFormFromURL();
      
      // Si le formulaire a été pré-rempli (redirection depuis sidebar), le soumettre automatiquement
      if (form) {
        autoSubmitForm(form);
      }
    }
    
    // Observer pour détecter le succès si formulaire soumis sans rechargement
    observeSuccessMessage();
  }
})();

